// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"163":"24ac01fb","265":"bb9fd8c3","383":"a395a54a"}[chunkId] + ".js";
};